import { AppNS } from '../../';
import snakeCaseKeys from 'snakecase-keys';

export const prepareRequestData = (data: AppNS.Params): AppNS.Params => {
  if (data) {
    // Exclude intentional all upper case object keys
    return snakeCaseKeys(data, { exclude: [/^[A-Z]*$/] });
  }
  return data;
};
